import "./App.css";

const projects = [
  {
    name: "Church-App",
    link: "https://church-app-drab-three.vercel.app/login",
    image: "/images/church-app.png",
    description: "A platfom to engage church members.",
    techStack: ["Next.js", "Typescript", "Tailwinds", "React", "Superbase", "Postgresql", "Claude-Code"],
  },
  {
    name: "Ventilator Lab",
    link: "https://vent-sim-front.vercel.app/?prototype",
    image: "/images/ventilator-lab.png",
    description:
      "A ventilator simulation application for learning how ventilator settings affect patient responses.",
    techStack: ["Java", "Javascript", "CSS", "Spring Boot", "Bootstrap"],
  },
  {
    name: "RT Smart Notes",
    link: "https://rt-smar-notes.netlify.app/",
    image: "/images/rt-smart-notes.png",
    description:
      "A Smart Notes Generator for Respiratory Therapists that quickly turns care and treatment inputs into clear, accurate clinical notes.",
    techStack: ["TypeScript", "Angular", "CSS"],
  },
  {
    name: "Woe Wear App",
    link: "https://woewear.netlify.app/",
    image: "/images/woeLogo.png",
    description: "An online store built for a seamless shopping experience.",
    techStack: ["React", "Node.js", "Express", "Firebase"],
  },
  {
    name: "ZipTube",
    link: "https://github.com/Ikejrmillsowoo/share-track-app",
    image: "/images/foodies.png",
    description: "A social media platform for sharing and tracking personal experiences.",
    techStack: ["Java", "Javascript", "CSS", "H2", "Spring Boot", "AWS S3"],
  },
  {
    name: "Tip Calculator App",
    link: "https://splitmybill.netlify.app/",
    image: "/images/tipCalc.png",
    description: "A simple tip calculator app to split bills easily.",
    techStack: ["HTML", "CSS", "JavaScript"],
  },
  {
    name: "Foodies App",
    link: "https://foodiesapp.netlify.app/",
    image: "/images/foodies.png",
    description:
      "Using the Yelp API, Express and React framework to create an app that searches businesses by location and a descriptive term.",
    techStack: ["React", "Node.js", "Heroku", "Yelp API"],
  },
  {
    name: "Book of Selasi",
    link: "https://selasik.netlify.app/",
    image: "/images/screencapture-selasik-netlify-app-2021-12-24-03_25_37.png",
    description: "A personal blog and portfolio site showcasing the work of a client.",
    techStack: ["HTML", "CSS", "JavaScript", "React"],
  },
];

const Projects = () => (
  <div className="container-fluid px-0">

    {/* Hero */}
    <div className="hero-wrap" style={{ marginBottom: "3rem" }}>
      <img src="/images/project-banner.png" alt="Projects Banner" />
      <div className="hero-overlay" />
      <div className="hero-content">
        <div className="hero-title">Projects</div>
        <p className="hero-subtitle">
          I am a software developer showcasing my skills through diverse projects.
        </p>
      </div>
    </div>

    <div className="container pb-5">
      <div className="text-center mb-5">
        <a
          href="https://github.com/Ikejrmillsowoo"
          target="_blank"
          rel="noopener noreferrer"
          className="github-cta"
        >
          <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.387.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.416-4.042-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.084-.729.084-.729 1.205.084 1.84 1.236 1.84 1.236 1.07 1.834 2.809 1.304 3.495.997.108-.775.418-1.305.762-1.605-2.665-.305-5.466-1.334-5.466-5.931 0-1.31.469-2.381 1.236-3.221-.124-.303-.535-1.523.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.553 3.297-1.23 3.297-1.23.653 1.653.242 2.873.119 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.803 5.624-5.475 5.921.43.372.823 1.102.823 2.222 0 1.606-.014 2.898-.014 3.293 0 .322.216.694.825.576C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
          </svg>
          Check out my GitHub for current projects
        </a>
      </div>

      <div className="row row-cols-1 row-cols-md-3 g-4">
        {projects.map((project, idx) => (
          <div className="col" key={idx}>
            <a
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              <div className="project-card">
                <div className="project-img-wrap">
                  <img src={project.image} alt={project.name} />
                  <div className="project-overlay">{project.name}</div>
                </div>
                <div className="project-body">
                  <div className="project-name">{project.name}</div>
                  <p className="project-desc">{project.description}</p>
                  <div>
                    {project.techStack.map((tech, i) => (
                      <span key={i} className="tech-badge">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Projects;
